<template>
  <el-row :gutter="24">
    <el-col :span="12">
      <base-form
        v-model="data"
        :options="options"
        :disabled="disabled"
        :colSpan="12"
        class="money-rate"
        labelWidth="100px"
        @input="handleChange"
      ></base-form>
    </el-col>
    <el-col :span="8" :offset="2">
      <el-row class="interest-text" :gutter="10">
        <el-col :span="2">{{ $t('contractAgency.moneyRateTab.rateFormCol1') }}</el-col>
        <el-col :span="11">{{ $t('contractAgency.moneyRateTab.rateFormCol2') }}</el-col>
        <el-col :span="8">{{ $t('contractAgency.moneyRateTab.rateFormCol3') }}</el-col>
      </el-row>
      <base-form
        v-model="data"
        :options="rightOptions"
        :disabled="disabled || !data.isInterest"
        :colSpan="24"
        labelWidth="60px"
      ></base-form>
    </el-col>
  </el-row>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  import { calAmount } from '@/common/js/contract-cal';
  import { spliceMoreZero } from '@/common/js/util';

  export default {
    props: {
      exchangeRate: {
        type: [Number, String],
        default: '',
      },
      defaultData: {
        type: Object,
        default: () => {},
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      baseForm,
    },
    data() {
      return {
        data: {
          fundAmountLocal: '',
          isInterest: true,
          overdualDays0: '',
          overdualMonthlyRate0: '',
          overdualDays1: '',
          overdualMonthlyRate1: '',
          overdualDays2: '',
          overdualMonthlyRate2: '',
          overdualDays3: '',
          overdualMonthlyRate3: '',
          overdualDays4: '',
          overdualMonthlyRate4: '',
        },
        formProps: [
          'interestRule',
          'startDate',
          'overdueDate',
          'fundAmount',
          'fundAmountLocal',
          'marginAmount',
          'overdualDays0',
          'overdualMonthlyRate0',
          'overdualDays1',
          'overdualMonthlyRate1',
          'overdualDays2',
          'overdualMonthlyRate2',
          'overdualDays3',
          'overdualMonthlyRate3',
          'overdualDays4',
          'overdualMonthlyRate4',
        ],
        amountProps: ['fundAmount'],
      };
    },
    computed: {
      options() {
        const disabled = !this.data.isInterest;
        return [
          {
            type: 'checkbox',
            label: this.$t('contractAgency.moneyRateTab.isInterest'),
            prop: 'isInterest',
            span: 24,
          },
          {
            type: 'input',
            label: this.$t('contractAgency.moneyRateTab.interestRule'),
            prop: 'interestRule',
            span: 24,
            disabled: disabled,
          },
          {
            type: 'startDate',
            label: this.$t('contractAgency.moneyRateTab.startDate'),
            prop: 'startDate',
            disabled: disabled,
          },
          {
            type: 'endDate',
            label: this.$t('contractAgency.moneyRateTab.overdueDate'),
            prop: 'overdueDate',
            disabled: disabled,
          },
          {
            type: 'sixNumber',
            label: this.$t('contractAgency.moneyRateTab.interestAmount'),
            prop: 'fundAmount',
            disabled: disabled,
          },
          {
            type: 'input',
            label: this.$t('contractAgency.moneyRateTab.interestAmountLocal'),
            prop: 'fundAmountLocal',
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('contractAgency.moneyRateTab.marginAmount'),
            prop: 'marginAmount',
            disabled: disabled,
            append: '元',
          },
        ];
      },
      rightOptions() {
        return [
          {
            label: this.$t('contractAgency.moneyRateTab.overdualDays'),
            children: [
              {
                type: 'sixNumber',
                prop: 'overdualDays0',
              },
              {
                type: 'sixNumber',
                prop: 'overdualMonthlyRate0',
                class: 'money-form-item',
                append: '‰',
              },
            ],
          },
          {
            label: this.$t('contractAgency.moneyRateTab.overdualDays1'),
            children: [
              {
                type: 'sixNumber',
                prop: 'overdualDays1',
              },
              {
                type: 'sixNumber',
                prop: 'overdualMonthlyRate1',
                append: '‰',
                max: 1000,
              },
            ],
          },
          {
            label: this.$t('contractAgency.moneyRateTab.overdualDays2'),
            children: [
              {
                type: 'sixNumber',
                prop: 'overdualDays2',
              },
              {
                type: 'sixNumber',
                prop: 'overdualMonthlyRate2',
                append: '‰',
                max: 1000,
              },
            ],
          },
          {
            label: this.$t('contractAgency.moneyRateTab.overdualDays3'),
            children: [
              {
                type: 'sixNumber',
                prop: 'overdualDays3',
              },
              {
                type: 'sixNumber',
                prop: 'overdualMonthlyRate3',
                append: '‰',
                max: 1000,
              },
            ],
          },
          {
            label: this.$t('contractAgency.moneyRateTab.overdualDays4'),
            children: [
              {
                type: 'sixNumber',
                prop: 'overdualDays4',
              },
              {
                type: 'sixNumber',
                prop: 'overdualMonthlyRate4',
                append: '‰',
                max: 1000,
              },
            ],
          },
        ];
      },
    },
    watch: {
      exchangeRate() {
        this.updateAmount();
      },
      defaultData() {
        const amountData = {};
        this.amountProps.forEach((prop) => {
          if (this.defaultData[prop]) {
            amountData[prop] = spliceMoreZero(this.defaultData[prop]);
            amountData[prop + 'Local'] = spliceMoreZero(this.defaultData[prop + 'Local']);
          }
        });
        const data = Object.assign(this.data, this.defaultData, amountData, {
          isInterest: this.defaultData.isInterest === 0 ? false : true,
        });
        this.data = data;
      },
    },
    methods: {
      getValues() {
        const data = this.data;
        const result = Object.assign({}, data, {
          isInterest: data.isInterest ? 1 : 0,
        });
        this.amountProps.forEach((prop) => {
          if (!result[prop]) {
            result[prop] = 0;
          }
        });
        return result;
      },
      // 表单变化
      handleChange(value, prop) {
        const index = this.amountProps.indexOf(prop);
        if (index > -1 && this.exchangeRate) {
          if (value[prop]) {
            // 需要计算本币
            calAmount(this.data[prop], this.exchangeRate).then((showLocal) => {
              this.data[prop + 'Local'] = showLocal;
            });
          } else {
            this.data[prop + 'Local'] = '';
          }
        }
        // 不收取利息，表单清空
        if (!value.isInterest && prop == 'isInterest') {
          const formProps = this.formProps;
          Object.keys(this.data).forEach((key) => {
            if (formProps.indexOf(key) > -1) {
              this.data[key] = '';
            }
          });
        }
      },
      // 更新本币计算
      updateAmount() {
        Object.keys(this.data).forEach((prop) => {
          if (this.amountProps.indexOf(prop) > -1 && this.data[prop]) {
            calAmount(this.data[prop], this.exchangeRate).then((showLocal) => {
              this.data[prop + 'Local'] = showLocal;
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .interest-text {
    font-size: 12px;
    color: #888;
    padding-bottom: 14px;
    font-weight: bold;
    line-height: 32px;
    .el-col:first-child {
      width: 60px;
      float: left;
      text-align: right;
      box-sizing: border-box;
      padding-right: 12px;
    }
  }
</style>
<style lang="scss">
  .money-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .money-rate {
    ::v-deep.el-form-item--small.propClass .el-form-item__label {
      line-height: 32px;
    }
  }
</style>
